import en from './locales/en'
import da from './locales/da'

export const ARGUS_DEFAULT_LOCALE = 'en'
export const ARGUS_SUPPORTED_LOCALES = Object.freeze([
  { code: 'en', label: 'English', shortLabel: 'EN' },
  { code: 'da', label: 'Dansk', shortLabel: 'DA' },
])

const dictionaries = Object.freeze({ en, da })

export function normalizeLocale(locale) {
  const code = String(locale ?? '')
    .trim()
    .toLowerCase()
    .split('-')[0]
  return Object.hasOwn(dictionaries, code) ? code : ARGUS_DEFAULT_LOCALE
}

function resolvePath(source, path) {
  return String(path ?? '')
    .split('.')
    .filter(Boolean)
    .reduce((value, key) => (value && typeof value === 'object' ? value[key] : undefined), source)
}

function interpolate(value, variables = {}) {
  return String(value).replace(/\{\{\s*([^}\s]+)\s*\}\}/g, (match, key) => {
    const replacement = variables[key]
    return replacement === null || replacement === undefined ? match : String(replacement)
  })
}

function stringPaths(source, prefix = '') {
  if (!source || typeof source !== 'object') return []
  return Object.entries(source).flatMap(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key
    return typeof value === 'string' ? [path] : stringPaths(value, path)
  })
}

export function translate(locale, key, variables = {}) {
  const normalized = normalizeLocale(locale)
  const localized = resolvePath(dictionaries[normalized], key)
  const fallback = resolvePath(dictionaries[ARGUS_DEFAULT_LOCALE], key)
  const value = typeof localized === 'string' ? localized : fallback
  return typeof value === 'string' ? interpolate(value, variables) : key
}

export function hasTranslation(locale, key) {
  return typeof resolvePath(dictionaries[normalizeLocale(locale)], key) === 'string'
}

export function getMissingTranslationKeys(locale) {
  const normalized = normalizeLocale(locale)
  if (normalized === ARGUS_DEFAULT_LOCALE) return []
  const required = stringPaths(dictionaries[ARGUS_DEFAULT_LOCALE])
  return required.filter((key) => typeof resolvePath(dictionaries[normalized], key) !== 'string')
}
